import clsx from "clsx";
import { useId } from "react";
import FieldLabel from "../FieldLabel/FieldLabel";

interface ITextAreaInput {
  label?: string;
  placeholder?: string;
  id?: string;
  required?: boolean;
  value?: string;
  onChange: (e: any) => void;
  type?: string;
  disabled?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  fontBold?: boolean;
  form?: string;
  onKeyDown?: (e: any) => void;
  className?: string;
  autoComplete?: string;
  rows?: number;
  spellCheck?: boolean;
}

const TextAreaInput: React.FC<ITextAreaInput> = ({
  label,
  placeholder,
  id,
  required,
  value = "",
  onChange,
  onKeyDown = () => {},
  type = "text",
  disabled = false,
  readOnly = false,
  autoFocus = false,
  fontBold = false,
  form = "",
  className = "",
  autoComplete,
  rows = 4,
  spellCheck = false,
}) => {
  const inputAutoId = useId();

  return (
    <div className="flex flex-col w-full gap-1">
      {label && (
        <FieldLabel
          required={required}
          text={label}
          valid={!!value}
          htmlFor={id || inputAutoId}
        />
      )}
      <textarea
        rows={rows}
        // x-webkit-speech
        spellCheck={spellCheck}
        value={value}
        id={id || inputAutoId}
        placeholder={placeholder}
        required={required}
        autoFocus={autoFocus}
        {...(form ? { form } : {})}
        autoComplete={autoComplete}
        className={clsx([
          // "text-gray-900",
          "dark:text-white",
          "border-solid",
          "border-2",
          "text-sm",
          "md:text-base",
          "w-full",
          "rounded-sm",
          // "focus:border-gray-500",
          "focus:outline-none",
          "placeholder:text-sm",
          "placeholder:font-light",
          "appearance-none",
          "min-w-full",
          // "bg-white/90",
          // "bg-white/90",
          // "dark:bg-gray-800/90",
          "bg-transparent",
          "p-2",
          {
            "border-red-300 dark:border-red-500": required && !value,
            "border-gray-200 dark:border-gray-600":
              (required && value) || !required,
            "font-light": !fontBold,
          },
          {
            "placeholder:text-gray-500 dark:placeholder:text-gray-300":
              !required,
            "placeholder:text-blue-500 dark:placeholder:text-purple-400":
              required,
          },
          className,
        ])}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        onKeyDown={onKeyDown}
        inputMode="text"
      />
    </div>
  );
};

export default TextAreaInput;
